import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import history from 'src/store/history';
import { getQuestionnaireIntro, showSpinnerEnableDisable } from 'src/ui/features/Questionnaire/state/questionnaireActions';
import { QuestionnaireLandingPres } from '../presentational/QuestionnaireLandingPres';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

class QuestionnaireLandingContainer extends Component {
  state = {
    readMore: false,
    showFirstSpinner:true,
  };

  async componentDidMount() {
    await this.props.showSpinnerEnableDisable(true);
    await this.getIntroData();
    await this.props.showSpinnerEnableDisable(false);
    this.setState({showFirstSpinner:false});
  }

  getIntroData = () => {
    const { getQuestionnaireIntro, match } = this.props;
    return getQuestionnaireIntro(match.params);
  };

  toggleReadMore = () => {
    this.setState(prevState => ({
      readMore: !prevState.readMore,
    }));
  };

  render() {
    const {showFirstSpinner}=this.state;
    return (
      <Fragment>
      {showFirstSpinner && <ServiceSpinner downlaodSpinner={showFirstSpinner} open={true} />}
      <QuestionnaireLandingPres {...this.props} readMore={this.state.readMore} toggleReadMore={this.toggleReadMore} />;
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  gettingIntroData: state.questionnaire.gettingIntroData,
  introData: state.questionnaire.intro,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  welcomeMessage: state.questionnaire.welcomeMessage,
});

const mapDispatchToProps = {
  getQuestionnaireIntro,
  push: url => () => history.push(url),
  goBack: () => () => history.goBack(),
  showSpinnerEnableDisable,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireLandingContainer);
